import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

interface Step {
  id: number;
  title: string;
  route: string;
  status: 'completed' | 'active' | 'pending';
}

@Component({
  selector: 'app-stepper-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper-grid.component.html',
  styleUrl: './stepper-grid.component.scss'
})
export class StepperGridComponent implements OnInit {
  private router = inject(Router);

  completionRoute = '/upload-bulk/social-ai-bulk-results';

  steps = signal<Step[]>([
    { id: 1, title: 'Upload Images', route: '/upload-bulk/social-ai-upload-images', status: 'pending' },
    { id: 2, title: 'Download File', route: '/upload-bulk/social-ai-download-file', status: 'pending'},
    { id: 3, title: 'Upload File', route: '/upload-bulk/social-ai-upload-bulk', status: 'pending' },
    { id: 4, title: 'Results', route: '/upload-bulk/social-ai-bulk-results', status: 'pending' },
    // { id: 4, title: 'Create & Approve', route: '/upload-bulk/create-approve', status: 'pending' },
  ]);


  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateStepStatus();
      });

    this.updateStepStatus();
  }

  updateStepStatus() {
    const currentRoute = this.router.url;

    if (currentRoute === this.completionRoute || currentRoute.startsWith(this.completionRoute)) {
      this.steps.update(prevSteps =>
        prevSteps.map(step => ({
          ...step,
          status: 'completed' as const
        }))
      );
      return;
    }

    const currentStepIndex = this.steps().findIndex(step =>
      currentRoute === step.route || currentRoute.startsWith(step.route)
    );

    this.steps.update(prevSteps =>
      prevSteps.map((step, index) => {
        if (currentStepIndex === -1) {
          return { ...step, status: 'pending' as const };
        }
        if (index === currentStepIndex) {
          return { ...step, status: 'active' as const };
        }
        if (index < currentStepIndex) {
          return { ...step, status: 'completed' as const };
        }
        return { ...step, status: 'pending' as const };
      })
    );
  }

  navigateToStep(step: Step) {
    if (step.status === 'completed' || step.status === 'active') {
      this.router.navigateByUrl(step.route);
    }
  }

  getStepClasses(status: 'completed' | 'active' | 'pending') {
    switch (status) {
      case 'completed':
        return 'bg-green-500 text-white';
      case 'active':
        return 'border-2 border-blue-600 bg-white text-blue-600';
      case 'pending':
        return 'border-2 border-gray-300 bg-white text-gray-400';
      default:
        return 'border-2 border-gray-300 bg-white text-gray-400';
    }
  }

  getTitleClasses(status: 'completed' | 'active' | 'pending') {
    switch (status) {
      case 'completed':
        return 'text-green-600';
      case 'active':
        return 'text-blue-600';
      case 'pending':
        return 'text-gray-500';
      default:
        return 'text-gray-500';
    }
  }

  getConnectorClasses(status: 'completed' | 'active' | 'pending') {
    switch (status) {
      case 'completed':
        return 'bg-green-500';
      case 'active':
        return 'bg-blue-600';
      case 'pending':
        return 'bg-gray-300';
      default:
        return 'bg-gray-300';
    }
  }
}
